import { gql } from "@apollo/client";

export interface ICreateVendorClientInput {
  name: string;
  country?: string;
  countryName?: string;
  // Sent over the wire as the GraphQL enum's name (e.g. "ACTIVE"/"INACTIVE"),
  // not the numeric TS enum value. Convert with EClientStatusEnum[value] at
  // each call site before assigning here.
  status?: string;
}

const CREATE_VENDOR_CLIENT = gql`
  mutation CreateVendorClient(
    $createVendorClientInput: CreateVendorClientInput!
  ) {
    createVendorClient(createVendorClientInput: $createVendorClientInput) {
      id
    }
  }
`;

const UPDATE_VENDOR_CLIENT = gql`
  mutation UpdateVendorClient(
    $id: String!
    $createVendorClientInput: CreateVendorClientInput!
  ) {
    updateVendorClient(
      id: $id
      createVendorClientInput: $createVendorClientInput
    ) {
      id
    }
  }
`;

export default { CREATE_VENDOR_CLIENT, UPDATE_VENDOR_CLIENT };
